module.exports = __webpack_public_path__ + "img/footer_logo.dc51b490.svg";